/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
// custom component import
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
// custom function import
import {
  radioGroupLabelNamePlan,
  rebateProgramLabelName,
  quarterLabelName,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  checkQuarterValidation,
  getCommonDropdownList,
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  setUnderThresholdInvoiceSearchTab,
  setPervSearchListRedux,
  setDetailsScreenTab,
  setSearchScreenTab,
  postSaveOrUpdate,
  dispatchUnderThresholdSearch,
  getUnderThresholdSearchRecord,
  getQuarterData,
  handleErrorMessagesUTI,
  getPlanTypeRadioBoxValue,
  getRebateProgramDropdownList,
} from '../store/Actions';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';

function UnderThresholdInvoiceSearchComponent() {
  const dispatch = useDispatch();
  const history = useHistory();
  // use Selector function

  const searchUnderThrInvTabData = useSelector(
    (state) =>
      state.sharedState.UnderThresholdInvoiceReducer?.searchUnderThInvScreenObj
  );

  const perviousUnderThInvSearchResultList = useSelector(
    (state) =>
      state.sharedState.UnderThresholdInvoiceReducer
        ?.perviousUnderThInvSearchRedux
  );
  const getQuarterDataValue = useSelector(
    (state) => state.sharedState.UnderThresholdInvoiceReducer.quarter
  );

  const errorMessagesFromRedux = useSelector(
    (state) =>
      state?.sharedState?.UnderThresholdInvoiceReducer?.errorMessagesInRedux
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  // variable deceleration
  const [planTypeOptions, setPlanTypeOptions] = React.useState([]);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [commonDropdownList, setCommonDropdownList] = React.useState([]);
  const handlingCodeList = [
    { name: 'All', value: 'All' },
    { name: 'Unspecified', value: 'Unspecified' },
    { name: 'Selected', value: 'Selected' },
  ];
  const [state, setState] = React.useState(
    searchUnderThrInvTabData?.state
      ? searchUnderThrInvTabData.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? userDefaults?.rebateProgramCd
            : '-1',
          invoiceHadingCd: '-1',
          selectByHandingCode: 'All',
          allSelect: 0,
          unSelect: 0,
          quarterValue: null,
        }
  );
  // handle all plan type get service
  React.useEffect(() => {
    handleScrollToEvent();
    getCommonDropdownList({
      codeDomainList: ['INVOICE_HANDLING_CD'],
    }).then((res) => {
      setCommonDropdownList(res);
    });
    getPlanTypeRadioBoxValue().then((res) => {
      const planList =
        res?.length > 0 &&
        res?.map((obj) => {
          return {
            name:
              obj?.codeValueID?.codeValue === 'FD'
                ? 'Medicaid'
                : obj.shortDescription,
            value: obj.codeValueID.codeValue,
          };
        });
      setPlanTypeOptions(planList);
    });
  }, []);

  // handling onPage load call service
  React.useEffect(() => {
    if (Object.keys(searchUnderThrInvTabData)?.length === 0) {
      dispatch(
        handleErrorMessagesUTI({
          searchScreenErrors: [],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
      dispatch(getQuarterData());
    }
  }, []);
  React.useEffect(() => {
  return () => {
    dispatch(
      handleErrorMessagesUTI({
        searchScreenErrors: [],
        detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors || [],
      })
    );
  };
}, []);
  // set common dropdown list
  // set common dropdown list after calling API service
  React.useEffect(() => {
    getRebateProgramDropdownList(state?.planTypeCd).then((res) => {
      let list = [];
      if (
        res?.status === constantMessageData.STATUS_MSG &&
        res?.message === constantMessageData.SUCCESS_MSG
      ) {
        if (!_.isEmpty(res.data)) {
          list = _.map(res.data, (val) => ({
            ...val,
            id: val.rebateProgramCd,
            name: `${val.rebateProgramCd} | ${val.shortDescr}`,
          }));
        }
      }
      setRebateProgramList(
        list.sort((key, val) =>
          key.name.toLowerCase().localeCompare(val.name.toLowerCase())
        )
      );
    });
  }, [state?.planTypeCd]);

  // set initial quarte Value
  React.useEffect(() => {
    let quarter = '';
    if (Object.keys(searchUnderThrInvTabData)?.length === 0) {
      if (!searchUnderThrInvTabData?.state?.quarterValue) {
        quarter = getQuarterDataValue;
        if (quarter) {
          setState({
            ...state,
            quarterValue: autoFormateDate(quarter?.toUpperCase()),
          });
          dispatch(
            setUnderThresholdInvoiceSearchTab({
              ...searchUnderThrInvTabData,
              state: {
                ...state,
                quarterValue: autoFormateDate(quarter?.toUpperCase()),
              },
            })
          );
        }
      }
    }
  }, [getQuarterDataValue]);
  // handing highlight tab
  React.useEffect(() => {
    if (
      errorMessagesFromRedux?.searchScreenErrors &&
      errorMessagesFromRedux?.searchScreenErrors.length > 0
    ) {
      tabHighLigther('/underThresholdInvoice', true);
    } else {
      tabHighLigther('/underThresholdInvoice', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  // handing On change event on filed level
  const handleOnChangeEvent = (value, name) => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    if (name === 'selectByHandingCode' && value !== 'Selected') {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'invoiceHadingCd' && item.field !== 'resultNotFound'
      );
      setState({ ...state, [name]: value, invoiceHadingCd: '-1' });
      dispatch(
        setUnderThresholdInvoiceSearchTab({
          ...searchUnderThrInvTabData,
          state: { ...state, [name]: value, invoiceHadingCd: '-1' },
        })
      );
      dispatch(
        handleErrorMessagesUTI({
          searchScreenErrors: [...new Set(localErr)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
    } else if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      dispatch(
        setUnderThresholdInvoiceSearchTab({
          ...searchUnderThrInvTabData,
          state: { ...state, [name]: value, rebateProgramCd: '-1' },
        })
      );
    } else {
      setState({ ...state, [name]: value });
      dispatch(
        setUnderThresholdInvoiceSearchTab({
          ...searchUnderThrInvTabData,
          state: { ...state, [name]: value },
        })
      );
    }
  };
  // hading On blur event on filed level
  const handleOnblurEvent = (type, value) => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
        );
      }
    }
    if (type === 'invoiceHadingCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'invoiceHadingCd' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'invoiceHadingCd',
          errorType: 'invoiceHadingCdRequired',
          message: constantMessageData.HANDING_CODE_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'invoiceHadingCd' && item.field !== 'resultNotFound'
        );
      }
    }
    if (type === 'quarter') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        localErr = localErr?.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        if (checkQuarterValidation(value)) {
          localErr = localErr?.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );
          setState({
            ...state,
            quarterValue: autoFormateDate(value?.toUpperCase()),
          });
          dispatch(
            setUnderThresholdInvoiceSearchTab({
              ...searchUnderThrInvTabData,
              state: {
                ...state,
                quarterValue: autoFormateDate(value?.toUpperCase()),
              },
            })
          );
        } else {
          localErr = localErr.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
          });
        }
      } else {
        localErr = localErr.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: constantMessageData.QUARTER_VALUE_REQUIRED,
        });
      }
    }
    dispatch(
      handleErrorMessagesUTI({
        searchScreenErrors: [...new Set(localErr)],
        detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
          ? errorMessagesFromRedux?.detailScreenErrors
          : [],
      })
    );
  };
  // redirect for display under threshold invoice page
  const handleViewDetailFunction = async () => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    if (
      state?.rebateProgramCd !== null &&
      state?.rebateProgramCd !== '-1' &&
      checkQuarterValidation(state.quarterValue)
    ) {
      if (
        state?.selectByHandingCode === 'Selected' &&
        (state?.invoiceHadingCd === null || state?.invoiceHadingCd === '-1')
      ) {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'invoiceHadingCd' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'invoiceHadingCd',
          errorType: 'invoiceHadingCdRequired',
          message: constantMessageData.HANDING_CODE_REQUIRED,
        });
        handleScrollToEvent();
      } else {
        const resultData = await dispatch(
          getUnderThresholdSearchRecord({
            planType: state?.planType,
            rebateProgramCd: state?.rebateProgramCd,
            qtr: state?.quarterValue,
            allSelect: state?.selectByHandingCode === 'All' ? 1 : 0,
            unSelect: state?.selectByHandingCode === 'Unspecified' ? 1 : 0,
            handlingCode:
              state?.selectByHandingCode === 'Selected'
                ? state?.invoiceHadingCd
                : null,
          })
        );
        dispatch(postSaveOrUpdate(null));
        if (resultData?.underThresholdSearchList?.length > 0) {
          dispatch(
            setPervSearchListRedux(resultData?.underThresholdSearchList)
          );
          dispatch(setSearchScreenTab({ state: state }));
          dispatch(setDetailsScreenTab({}));
          localErr = localErr.filter((item) => item.field !== 'resultNotFound');
          redirectURLLink(
            '/viewUnderThresholdInvoice',
            'Display Under Threshold Invoices',
            history,
            dispatch
          );
        } else {
          dispatch(
            dispatchUnderThresholdSearch(perviousUnderThInvSearchResultList)
          );
          let checkSechError = [];
          checkSechError = localErr.filter(
            (item) => item.errorType === 'dataNotSelected'
          );
          checkSechError = localErr.filter(
            (item) => item.errorComponent !== 'searchTypeComponent'
          );
          if (!checkSechError.length > 0) {
            localErr = localErr.filter(
              (item) => item.field !== 'resultNotFound'
            );
            localErr.push({
              field: 'resultNotFound',
              errorType: 'resultNotFound',
              errorComponent: 'searchTypeComponent',
              message: constantMessageData.MNFC_NDC_ERROR_MSG,
            });
            handleScrollToEvent();
          }
        }
      }
    } else if (
      state.rebateProgramCd === null ||
      state.rebateProgramCd === '-1'
    ) {
      localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED,
      });
    } else if (state.quarterValue === '') {
      localErr = localErr.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: constantMessageData.QUARTER_VALUE_REQUIRED,
      });
    } else if (!checkQuarterValidation(state.quarterValue)) {
      localErr = localErr.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'invalidFormat',
        message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
      });
    }
    if (localErr && !localErr.length > 0) {
      tabHighLigther('/underThresholdInvoice', false);
    }
    dispatch(
      handleErrorMessagesUTI({
        searchScreenErrors: [...new Set(localErr)],
        detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
          ? errorMessagesFromRedux?.detailScreenErrors
          : [],
      })
    );
  };
  return (
    <div
      className="tabs-container"
      data-testid="UnderThresholdInvoiceSearchComponent"
    >
      <CustomSeparator
        parent1="Research"
        parent2="Select Under Threshold Invoices"
      />
      <DisplayErrorMessages
        errorMessages={[
          ...new Set(
            errorMessagesFromRedux?.searchScreenErrors?.length > 0
              ? _.map(
                  errorMessagesFromRedux.searchScreenErrors,
                  (l) => l.message
                )
              : []
          ),
        ]}
      />
      <Spinner load={spinnerLoader} />
      <div className="row align-item-center">
        <div className="col-12 col-sm-12 col-md-5 frr-radio-40per-width">
          <RadioGroupComponent
            data-testid="filter-plan-by-radio-btn-plan"
            id="filter-plan-by-radio-btn-action"
            labelName={radioGroupLabelNamePlan}
            required={false}
            optionList={planTypeOptions}
            defaultValue={state && state.planTypeCd}
            filterAction={(e) => {
              handleOnChangeEvent(e, 'planTypeCd');
            }}
            className="log-batch-filter-radio frr-checkInvoiceRadio"
          />
        </div>

        <div className="col-12 col-sm-12 col-md-7 frr-checkInvoiceRebate">
          <div className="mt-2">
            <fieldset className="custom-fieldset">
              <legend aria-hidden="true" className="d-none" />
              <div className="form-wrapper my-2">
                <div className="mui-custom-form with-select">
                  <TextField
                    data-testid="rebate_program1"
                    id="rebate_program"
                    label={rebateProgramLabelName}
                    fullWidth
                    select
                    required
                    placeholder=""
                    inputProps={{ maxLength: 11, id: 'rebate_program' }}
                    onBlur={(e) =>
                      handleOnblurEvent('rebateProgramCd', e.target.value)
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={state && state.rebateProgramCd}
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                    }
                    className={
                      errorMessagesFromRedux?.searchScreenErrors?.length > 0
                        ? _.map(
                            errorMessagesFromRedux.searchScreenErrors,
                            (l) =>
                              l.field === 'rebateProgramCd'
                                ? 'mandate-fields'
                                : null
                          )
                        : null
                    }
                    helperText={
                      errorMessagesFromRedux?.searchScreenErrors?.length > 0
                        ? _.map(
                            errorMessagesFromRedux.searchScreenErrors,
                            (l) =>
                              l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                    error={
                      errorMessagesFromRedux?.searchScreenErrors?.length > 0
                        ? _.map(
                            errorMessagesFromRedux.searchScreenErrors,
                            (l) =>
                              l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                  >
                    <MenuItem
                      key=""
                      value="-1"
                      className="frr-dropdown-blank-item"
                    />
                    {rebateProgramList &&
                    rebateProgramList.length &&
                    rebateProgramList.length > 0
                      ? rebateProgramList.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
                <div className="mui-custom-form input-md frr-check-invoice-quater">
                  <TextField
                    data-testid="check_quarter_ia"
                    id="check_by_invoice_quater"
                    required
                    label={quarterLabelName}
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 6 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={state && state.quarterValue}
                    onChange={(e) => {
                      handleOnChangeEvent(e.target.value, 'quarterValue');
                    }}
                    onBlur={(e) => handleOnblurEvent('quarter', e.target.value)}
                    className={
                      errorMessagesFromRedux?.searchScreenErrors?.length > 0
                        ? _.map(
                            errorMessagesFromRedux.searchScreenErrors,
                            (l) =>
                              l.field === 'quarter' ? 'mandate-fields' : null
                          )
                        : null
                    }
                    helperText={[
                      ...new Set(
                        errorMessagesFromRedux?.searchScreenErrors?.length > 0
                          ? _.map(
                              errorMessagesFromRedux.searchScreenErrors,
                              (l) => (l.field === 'quarter' ? l.message : null)
                            )
                          : null
                      ),
                    ]}
                    error={[
                      ...new Set(
                        errorMessagesFromRedux?.searchScreenErrors?.length > 0
                          ? _.map(
                              errorMessagesFromRedux.searchScreenErrors,
                              (l) => (l.field === 'quarter' ? l.message : null)
                            )
                          : null
                      ),
                    ]}
                  />
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <fieldset className="custom-fieldset h-100 frr-checkboxBtnGroup">
          <legend>Invoice Handling Codes</legend>
          <div className="form-wrapper db">
            <div className="sub-radio no-margin">
              <FormControl>
                <RadioGroup
                  row
                  name="quarter-radio"
                  defaultValue={state && state.selectByHandingCode}
                  value={state && state.selectByHandingCode}
                  data-testid="quarter-radio-box-group-control"
                >
                  {!_.isEmpty(handlingCodeList)
                    ? handlingCodeList.map((v) => (
                        <FormControlLabel
                          value={v.value}
                          control={
                            <Radio
                              onChange={() =>
                                handleOnChangeEvent(
                                  v.value,
                                  'selectByHandingCode'
                                )
                              }
                            />
                          }
                          label={v.name}
                          key={v.value && _.kebabCase(v.value)}
                        />
                      ))
                    : null}
                </RadioGroup>
              </FormControl>
            </div>
            <div className=" col-4 pl-0">
              <div className="mui-custom-form with-select ">
                <TextField
                  data-testid="rebate_program2"
                  id="invoiceHadingCd"
                  label="Handling Code"
                  fullWidth
                  select
                  disabled={state?.selectByHandingCode !== 'Selected'}
                  required={state?.selectByHandingCode === 'Selected'}
                  placeholder=""
                  inputProps={{ maxLength: 11, id: 'invoiceHadingCd' }}
                  onBlur={(e) =>
                    handleOnblurEvent('invoiceHadingCd', e.target.value)
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={state?.invoiceHadingCd}
                  onChange={(e) =>
                    handleOnChangeEvent(e.target.value, 'invoiceHadingCd')
                  }
                  className={
                    errorMessagesFromRedux?.searchScreenErrors?.length > 0
                      ? _.map(errorMessagesFromRedux.searchScreenErrors, (l) =>
                          l.field === 'invoiceHadingCd'
                            ? 'mandate-fields'
                            : null
                        )
                      : null
                  }
                  helperText={
                    errorMessagesFromRedux?.searchScreenErrors?.length > 0
                      ? _.map(errorMessagesFromRedux.searchScreenErrors, (l) =>
                          l.field === 'invoiceHadingCd' ? l.message : null
                        )
                      : null
                  }
                  error={
                    errorMessagesFromRedux?.searchScreenErrors?.length > 0
                      ? _.map(errorMessagesFromRedux.searchScreenErrors, (l) =>
                          l.field === 'invoiceHadingCd' ? l.message : null
                        )
                      : null
                  }
                >
                  <MenuItem
                    key=""
                    value="-1"
                    className="frr-dropdown-blank-item"
                  />

                  {commonDropdownList?.INVOICE_HANDLING_CD?.length > 0
                    ? commonDropdownList?.INVOICE_HANDLING_CD?.map((item) => {
                        return (
                          <MenuItem
                            key={item.codeValueID && item.codeValueID.codeValue}
                            value={
                              item.codeValueID && item.codeValueID.codeValue
                            }
                          >
                            {`${
                              item.codeValueID && item.codeValueID.codeValue
                            } | ${item.shortDescription}`}
                          </MenuItem>
                        );
                      })
                    : null}
                </TextField>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div className="mui-custom-form input- pt-3 frr-search text-right frr-width-75per float-right">
        <Button
          className="btn btn-success btn-search"
          data-testid="view_detail_ia"
          type="button"
          onClick={() => handleViewDetailFunction()}
        >
          {' '}
          <SVGComponent iconName="Icon-search" /> {'  '} Search
        </Button>
      </div>
    </div>
  );
}
export default UnderThresholdInvoiceSearchComponent;
